import React from 'react';
import { Facebook, Twitter, Instagram } from 'lucide-react';
import { motion } from 'framer-motion';
import "../css/Header.css";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { User, LogOut, UserCircle } from "lucide-react";
import config from '../config';
import { Link } from "react-router-dom";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const auth = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  const signOutRedirect = () => {
    const clientId = config.clientId;
    const logoutUri = config.logoutUri;
    const cognitoDomain = config.cognitoDomain;
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
    auth.removeUser();
  };

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-content">

          <Link to="/" className="logo-container">
            <img src="/logo1.PNG" alt="Prep4Success Kids" className="logo-img" />
          </Link>


          <div className="nav-links">
            <a href="/about" className="nav-link">About</a>
            <a href="/contact" className="nav-link">Contact</a>
          </div>

          <div className="account-section">
            {auth.isAuthenticated ? (
              <div className="account-menu">
              <button className="avatar-button" onClick={() => setMenuOpen(!menuOpen)}>
                <img src="/account.PNG" alt="User Avatar" className="avatar-image" />
              </button>

                {menuOpen && (
                  <div className="dropdown-menu">
                    <button className="menu-item" onClick={() => window.location.href = "/account"}>
                      <User size={18} /> Account Details
                    </button>
                    <button className="menu-item logout" onClick={() => signOutRedirect()}>
                      <LogOut size={18} /> Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <button className="cta-button" onClick={() => auth.signinRedirect()}>My Account</button>
            )}
          </div>

          <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X className="icon" /> : <Menu className="icon" />}
          </div>
        </div>
      </nav>

      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="mobile-menu"
        >
          <a href="#about" className="mobile-link">About</a>
          <a href="/contact" className="mobile-link">Contact</a>
        </motion.div>
      )}
    </div>
  );
};

export default Header;





